import type { MultiLocationSuggestOption } from '@property.com.au/ui-kit';

export const arrayToMultiLocationSuggestOptions = (
  values: string[],
): MultiLocationSuggestOption[] => values.map((value) => ({ display: { text: value } }));
